import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'

import type { ThankYou } from '../../../../ThankYous.types'
import * as S from './OrderDetails.styled'

export type OrderDetailsProps = {
  thankYou: ThankYou
}

export const OrderDetails = ({ thankYou }: OrderDetailsProps) => {
  return (
    <S.Container>
      {!!thankYou.tags.length && (
        <S.Badges>
          {thankYou.tags.map((tag) => (
            <S.Badge key={tag}>{tag}</S.Badge>
          ))}
        </S.Badges>
      )}

      {!!thankYou.offers.length && (
        <S.Products>
          {thankYou.offers.map((offer, index) => (
            <S.Product key={index}>
              <PhotoThumbnail url={offer.thumbnailImageUrl} size="small" />
              <S.ProductTitle>{offer.title}</S.ProductTitle>
            </S.Product>
          ))}
        </S.Products>
      )}

      {!!thankYou.message.length && <S.Message>“{thankYou.message}”</S.Message>}
    </S.Container>
  )
}
